// extracted by mini-css-extract-plugin
export default {"button":"GameSkipper_button__4XjJ7"};